type Props = {
  redirectedRetailerName: string;
};

const RedirectBanner = ({ redirectedRetailerName }: Props) => {
  return (
    <div className="flex items-center gap-4 rounded-lg bg-grey-panel p-4">
      <div className="flex h-6 items-center rounded-[20px] border border-solid border-green-human bg-white px-2 py-1">
        <span className="whitespace-nowrap text-[10px] font-semibold leading-[18px] text-green-human">
          In stock
        </span>
      </div>
      <span className="text-sm font-normal leading-[22px] text-black">
        You just missed it at {redirectedRetailerName}. But we have stock on the
        marketplace, select your size now.
      </span>
    </div>
  );
};

export default RedirectBanner;
